import moment from 'moment';
import { filter } from 'lodash-es';

const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export const decimal = (number, precision = 2) => Number(number).toFixed(precision);
export const enumeration = (...items) => filter(items).join(', ');
export const currency = amount => currencyFormatter.format(amount);
export const date = date => moment(date).format('L');
